<template>
  <div class="open-app">
    <p>Redirecting…</p>
  </div>
</template>

<script>
export default {
  name: "OpenApp",
  mounted() {
    const ua = navigator.userAgent || navigator.vendor;
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);

    if (!isIOS && !isAndroid) {
      this.$router.push('/public/default/connexion');
      return;
    }

    const configs = window.configs || {};
    const schemaUrl = configs.VUE_APP_SCHEMA_URL || process.env.VUE_APP_SCHEMA_URL || '';
    const storeUrl = isIOS
      ? (configs.VUE_APP_APPLE_APP_URL || process.env.VUE_APP_APPLE_APP_URL)
      : (configs.VUE_APP_ANDROID_APP_URL || process.env.VUE_APP_ANDROID_APP_URL);

    // Transmet les query params (?screen=mission-sheet&missionId=...) au custom scheme
    if (schemaUrl) {
      window.location.href = schemaUrl + window.location.search;
    }

    // Si l'app n'est pas installée, le custom scheme échoue silencieusement :
    // fallback vers le Store après le délai
    setTimeout(() => {
      window.location.replace(storeUrl);
    }, 1500);
  }
};
</script>
